import React from 'react'

function DailyExpenseInfo() {
  return (
    <div>DailyExpenseInfo</div>
  )
}

export default DailyExpenseInfo